import { memo } from 'react';
import { StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { Box, useStyle } from '@bonanza-social/moonlight';
import { FADE_BACKGROUND, FADE_CONFIG } from './CustomCategoryFade.content';
import { CustomCategoryFadeProps } from './CustomCategoryFade.types';

function CustomCategoryFade({ direction }: CustomCategoryFadeProps) {
  const { backgroundColor: gradientColor } = useStyle({
    backgroundColor: FADE_BACKGROUND,
  });
  const { style, ...rest } = FADE_CONFIG[direction];

  return (
    <Box position="absolute" {...style}>
      <LinearGradient
        colors={[gradientColor, 'transparent']}
        style={StyleSheet.absoluteFill}
        locations={[0.211, 0.997]}
        {...rest}
      />
    </Box>
  );
}

export default memo(CustomCategoryFade);
